export const TYPE_STRING = 'TYPE_STRING';
export const TYPE_COLLECTION = 'TYPE_COLLECTION';
export const TYPE_DATE_COMPARISON = 'TYPE_DATE_COMPARISON';
export const TYPE_ENUM = 'TYPE_ENUM';
export const TYPE_BOOLEAN = 'TYPE_BOOLEAN';
export const TYPE_NUMBER = 'TYPE_NUMBER';
